import {Injectable} from '@angular/core';
import {environment} from "../../environments/environment";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root',
})
export class ImageService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {
  }

  getImageUrl(image: string): string {
    return `${this.apiUrl}/image?picName=${image}`;
  }

  resolveImageSrc(image: string | null): string {
    if (!image) return '';
    if (image.startsWith('http://') || image.startsWith('https://') ||
        image.startsWith('data:') || image.startsWith('/')) {
      return image;
    }
    return this.getImageUrl(image);
  }

}
